import { create } from "zustand";
import { persist } from "zustand/middleware";

export const THEMES = [
  { name: "Indigo",  color: "#6366f1" },
  { name: "Blue",    color: "#2563eb" },
  { name: "Sky",     color: "#0284c7" },
  { name: "Cyan",    color: "#0891b2" },
  { name: "Teal",    color: "#0d9488" },
  { name: "Violet",  color: "#7c3aed" },
  { name: "Fuchsia", color: "#c026d3" },
  { name: "Pink",    color: "#db2777" },
  { name: "Rose",    color: "#e11d48" },
  { name: "Orange",  color: "#ea580c" },
  { name: "Amber",   color: "#d97706" },
  { name: "Slate",   color: "#475569" },
];

export const useThemeStore = create(
  persist(
    (set) => ({
      themeColor: "#6366f1",
      isDark:     false,
      setThemeColor: (color) => set({ themeColor: color }),
      toggleDark:    ()      => set((s) => ({ isDark: !s.isDark })),
    }),
    { name: "vp-theme" }
  )
);
